import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteEventShotClass = (shotclassId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.EVENTS.DELETE_SHOTCLASS(shotclassId)
  );
};

export default deleteEventShotClass;
